class Video {
  constructor () {
    this.$videoContainers = document.querySelectorAll('.js-video-container')
    this.init()
    this.createVideo()
  }

  init () {
    if (this.$videoContainers) {
      const youtubeScriptId = 'youtube-api'
      const youtubeScript = document.getElementById(youtubeScriptId)

      if (youtubeScript === null) {
        const tag = document.createElement('script')
        const firstScript = document.getElementsByTagName('script')[0]

        tag.src = 'https://www.youtube.com/iframe_api'
        tag.id = youtubeScriptId
        firstScript.parentNode.insertBefore(tag, firstScript)
      }

      this.createVideo()
    }
  }

  createVideo () {
    const onPlayerStateChange = (e) => {
      if (e.data === window.YT.PlayerState.PLAYING) {
        const $parent = e.target.g.parentNode
        const $captions = $parent.querySelector('.video-caption')

        if ($captions) {
          $captions.style.display = 'none'
        }
      }
    }

    window.onYouTubeIframeAPIReady = () => {
      this.$videoContainers.forEach(el => {
        const iframe = el.querySelector('.js-youtube-iframe')
        const videoId = iframe.getAttribute('data-url')

        this.player = new window.YT.Player(iframe, {
          videoId,
          height: '100%',
          width: '100%',
          events: {
            onStateChange: onPlayerStateChange
          }
        })

        const $button = el.querySelector('.video-button')

        if ($button) {
          $button.addEventListener('click', () => {
            const $image = el.querySelector('.video-visuel')
            const $bg = el.querySelector('.video-image')
            const $iframe = el.querySelector('.js-youtube-iframe')
            const $captions = el.querySelector('.video-caption')

            $button.style.display = 'none'

            if ($image) {
              $bg.style.background = 'none'
            }

            if ($image) {
              $image.style.display = 'none'
            }

            if ($captions) {
              $captions.style.display = 'none'
            }

            const src = $iframe.getAttribute('src')
            $iframe.setAttribute('src', src + '&autoplay=1')
          })
        }
      })
    }
  }
}

export default Video
